"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var WindowStateEnum_1 = require("../../window/model/WindowStateEnum");

var WindowChangeType_1 = require("./WindowChangeType");
/**
 * @author OPt
 * @author Adam Drda
 */


var ForecastChangeWindowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastChangeWindowDTO, _DomainObject_1$Domai);

  function ForecastChangeWindowDTO(promotionCode, promotionTypeId, promotionWorkflowState, promotionDateFrom, storeSpecification, windowId, windowName, windowTypeId, windowDateFrom, windowDateTo, windowWorkflowState, validDaysCount, skuCount, windowChangeType, // KPIs
  sales, promoVolume, gm, gmPercentage, proxyBm2, proxyBm2Percentage) {
    var _this;

    _classCallCheck(this, ForecastChangeWindowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeWindowDTO).call(this));
    _this.promotionCode = promotionCode;
    _this.promotionTypeId = promotionTypeId;
    _this.promotionWorkflowState = promotionWorkflowState;
    _this.promotionDateFrom = promotionDateFrom;
    _this.storeSpecification = storeSpecification;
    _this.windowId = windowId;
    _this.windowName = windowName;
    _this.windowTypeId = windowTypeId;
    _this.windowDateFrom = windowDateFrom;
    _this.windowDateTo = windowDateTo;
    _this.windowWorkflowState = windowWorkflowState;
    _this.validDaysCount = validDaysCount;
    _this.skuCount = skuCount;
    _this.windowChangeType = windowChangeType;
    _this.sales = sales;
    _this.promoVolume = promoVolume;
    _this.gm = gm;
    _this.gmPercentage = gmPercentage;
    _this.proxyBm2 = proxyBm2;
    _this.proxyBm2Percentage = proxyBm2Percentage;
    return _this;
  }

  return ForecastChangeWindowDTO;
}(DomainObject_1.DomainObject);

exports.ForecastChangeWindowDTO = ForecastChangeWindowDTO;

ForecastChangeWindowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastChangeWindowDTO.name);
  return {
    promotionCode: builder.str('promotionCode'),
    promotionTypeId: builder.id('promotionTypeId'),
    promotionWorkflowState: builder.opt(builder.senum('promotionWorkflowState', PromotionStateEnum_1.PromotionStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionWorkflowState)),
    promotionDateFrom: builder.date('promotionDateFrom', DateParser_1.DateParser.ISO_PATTERN),
    storeSpecification: builder.senum('storeSpecification', StoreSpecificationEnum_1.StoreSpecificationEnum, CodebookLookupSequence_1.CodebookLookupSequence.StoreSpecification),
    windowId: builder.str('windowId'),
    windowName: builder.str('windowName'),
    windowTypeId: builder.id('windowTypeId'),
    windowDateFrom: builder.date('windowDateFrom', DateParser_1.DateParser.ISO_PATTERN),
    windowDateTo: builder.date('windowDateTo', DateParser_1.DateParser.ISO_PATTERN),
    windowWorkflowState: builder.opt(builder.senum('windowWorkflowState', WindowStateEnum_1.WindowStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.WindowWorkflowState)),
    validDaysCount: builder.num('validDaysCount'),
    skuCount: builder.num('skuCount'),
    windowChangeType: builder.senum('windowChangeType', WindowChangeType_1.WindowChangeType, CodebookLookupSequence_1.CodebookLookupSequence.WindowChangeType),
    sales: builder.data('sales', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    promoVolume: builder.data('promoVolume', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    gm: builder.data('gm', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    gmPercentage: builder.data('gmPercentage', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    proxyBm2: builder.data('proxyBm2', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    }),
    proxyBm2Percentage: builder.data('proxyBm2Percentage', {
      oldValue: builder.opt(builder.bigNum('oldValue')),
      newValue: builder.opt(builder.bigNum('newValue')),
      difference: builder.opt(builder.bigNum('difference'))
    })
  };
}();

ForecastChangeWindowDTO.dataOrder = [ForecastChangeWindowDTO.schema.promotionCode.simpleNameKey(), ForecastChangeWindowDTO.schema.promotionTypeId.simpleNameKey(), ForecastChangeWindowDTO.schema.promotionDateFrom.simpleNameKey(), ForecastChangeWindowDTO.schema.promotionWorkflowState.simpleNameKey(), ForecastChangeWindowDTO.schema.storeSpecification.simpleNameKey(), ForecastChangeWindowDTO.schema.windowTypeId.simpleNameKey(), ForecastChangeWindowDTO.schema.windowName.simpleNameKey(), ForecastChangeWindowDTO.schema.windowDateFrom.simpleNameKey(), ForecastChangeWindowDTO.schema.windowDateTo.simpleNameKey(), ForecastChangeWindowDTO.schema.windowWorkflowState.simpleNameKey(), ForecastChangeWindowDTO.schema.validDaysCount.simpleNameKey(), ForecastChangeWindowDTO.schema.skuCount.simpleNameKey(), ForecastChangeWindowDTO.schema.windowChangeType.simpleNameKey(), ForecastChangeWindowDTO.schema.sales.simpleNameKey(), ForecastChangeWindowDTO.schema.promoVolume.simpleNameKey(), ForecastChangeWindowDTO.schema.gm.simpleNameKey(), ForecastChangeWindowDTO.schema.gmPercentage.simpleNameKey(), ForecastChangeWindowDTO.schema.proxyBm2.simpleNameKey(), ForecastChangeWindowDTO.schema.proxyBm2Percentage.simpleNameKey()];